"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type FC, type PropsWithChildren, use, useState } from "react";
import { useStore } from "zustand";
import { createQuizzesStore, type QuizzesState, type QuizzesStore } from "~/client/services";
interface QuizzesStoreProviderProps {
  readonly initialState?: QuizzesState;
}
type QuizzesStoreApi = ReturnType<typeof createQuizzesStore>;
export const QuizzesStoreContext = createContext<QuizzesStoreApi | undefined>(undefined);
export const QuizzesStoreProvider: FC<PropsWithChildren<QuizzesStoreProviderProps>> = t0 => {
  const $ = _c(7);
  const {
    children,
    initialState: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      data: [],
      isPending: false
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const initialState = t2;
  let t3;
  if ($[2] !== initialState) {
    t3 = () => createQuizzesStore(initialState);
    $[2] = initialState;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [store] = useState(t3);
  let t4;
  if ($[4] !== children || $[5] !== store) {
    t4 = <QuizzesStoreContext value={store}>{children}</QuizzesStoreContext>;
    $[4] = children;
    $[5] = store;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const useQuizzesStore = selector => {
  const store = use(QuizzesStoreContext);
  if (!store) {
    throw new Error("useQuizzesStore must be used within a QuizzesStoreProvider");
  }
  return useStore(store, selector);
};